import React from 'react';
import { Instagram, Mail } from 'lucide-react';
import { SITE, NAV } from '../../mock';

export default function Footer() {
  return (
    <footer className="relative border-t border-white/5 bg-navy-950">
      <div className="max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <img
            src="/images/logo.png"
            alt="Nishit Thakkar"
            className="h-14 w-auto rounded-xl object-contain"
          />
          <p className="mt-4 text-neutral-400 text-sm leading-relaxed max-w-xs">
            Manifestation Meets Business Implementation&trade;. Transform your inner reality,
            build your business systems, create measurable growth.
          </p>
          <p className="mt-4 font-serif italic text-amber-200/90 text-[15px]">
            Inner Alignment + Strategic Action = Quantum Growth&trade;
          </p>
        </div>

        <div>
          <p className="text-[11px] tracking-[0.22em] uppercase text-neutral-500 mb-4">
            Navigate
          </p>
          <ul className="space-y-2.5">
            {NAV.map((n) => (
              <li key={n.label}>
                <a href={n.href} className="text-neutral-300 hover:text-amber-300 text-sm transition-colors">
                  {n.label}
                </a>
              </li>
            ))}
            <li>
              <a href="#apply" className="text-neutral-300 hover:text-amber-300 text-sm transition-colors">
                Apply
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="text-[11px] tracking-[0.22em] uppercase text-neutral-500 mb-4">
            Connect
          </p>
          <div className="flex items-center gap-3">
            <SocialBtn href="/book" label="Book">
              <BookIcon />
            </SocialBtn>
            <SocialBtn
              href="https://www.instagram.com/manifest_with_nishit?igsh=MThudmxwNWRhZGlycg%3D%3D&utm_source=qr"
              label="Instagram"
            >
              <Instagram size={18} />
            </SocialBtn>
            <SocialBtn href="mailto:info@nishitthakkar.in" label="Email">
              <Mail size={18} />
            </SocialBtn>
          </div>
          <p className="mt-6 text-xs text-neutral-500 leading-relaxed">
            For consulting enquiries:
            <br />
            <a className="text-neutral-300 hover:text-amber-300" href="mailto:info@nishitthakkar.in">
              info@nishitthakkar.in
            </a>
          </p>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-neutral-500">
          <p>© {new Date().getFullYear()} Nishit Thakkar. All rights reserved.</p>
          <p>Crafted with intention. Mind. Energy. Action.</p>
        </div>
      </div>
    </footer>
  );
}

function SocialBtn({ href, label, children }) {
  return (
    <a
      href={href}
      aria-label={label}
      target={href.startsWith('http') ? '_blank' : undefined}
      rel="noreferrer"
      className="w-10 h-10 inline-flex items-center justify-center rounded-full border border-white/10 text-neutral-300 hover:text-amber-300 hover:border-amber-300/40 transition-colors"
    >
      {children}
    </a>
  );
}

function BookIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M4 4.5A2.5 2.5 0 0 1 6.5 2H20v18H6.5A2.5 2.5 0 0 1 4 17.5v-13Z" />
      <path d="M4 17.5A2.5 2.5 0 0 1 6.5 15H20" />
    </svg>
  );
}
